import { Box } from "@mui/material";
import { Info } from "@mui/icons-material";
import { useState } from "react";
import { Projeto } from "src/components/projetos/types";
import { InputDecimal3 } from "src/framework/components/forms/inputs/InputDecimal3"
import { setServicoInformationModalStatus } from "src/store/vendas/projetos/actions";
import { alterandoServico$ } from "src/store/vendas/projetos/store";

interface InputValorServicoProps {
  formState: Projeto
  setFormState: (newState: Partial<Projeto>) => void
  servicoObrigatorio: boolean;
  valorMinimoServico?: number;
}

function Sufix() {
  return (
    <Box
      onClick={() => setServicoInformationModalStatus(true)}
      component={"button"}
      border={"none"}
      bgcolor={"transparent"}
      style={{ cursor: 'pointer', outline: 'none' }}
    >
      <Info
        color={"primary"}
        fontSize={"small"}
      />
    </Box>
  )
}

function InputValorServico({ formState, valorMinimoServico, setFormState, servicoObrigatorio }: InputValorServicoProps) {
  const [valor, setValor] = useState(String(formState?.valor_servico || ''))

  return (
    <InputDecimal3
      InputLabelProps={{ shrink: true }}
      label={`${servicoObrigatorio ? '*' : ''} Valor do serviço líquido (R$)`}
      margin="normal"
      disabled={!servicoObrigatorio}
      decimal={2}
      maxLength={15}
      sufix={<Sufix />}
      prefix={valor ? <>R$&nbsp;</> : ''}
      placeholder="R$ 0,00"
      helperText={!!valorMinimoServico && valorMinimoServico > 0 && valorMinimoServico > Number(valor) ? `Para inserir o valor de serviço na plataforma o valor mínimo tem que ser de ${Intl.NumberFormat('pt-BR', { style: "currency", currency: "BRL" }).format(valorMinimoServico)}` : ''}
      value={String(valor || '')}
      onChange={(event: any) => {
        const normalized = event.target.value ? event.target.value.replace(',', '.') : '0'
        setValor(normalized)
      }}
      onBlur={() => {
        setFormState({ valor_servico: Number(valor), recalcular: formState?.isEdit })
        setTimeout(() => alterandoServico$.next(false), 500);
      }}
      onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "-") {
          event.preventDefault();
        }
      }}
      onFocus={() => {
        alterandoServico$.next(true);
      }}
      InputProps={{
        onInput: (event: any) => {
          const value = event.target.value
          const cleanedText = value.replace(/-/g, '');
          event.target.value = cleanedText
        }
      }}
    />
  );
}

export { InputValorServico }